<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"></v-progress-circular>
  <div v-else class="login-form pt-10">
    <form @submit="setStorage" class="form pt-15">
      <div class="username">
        <label for="usernameInput">Username: </label>
        <b-form-input
          id="usernameInput"
          v-model="username"
          type="text"
          placeholder="Enter Username"
          required></b-form-input>
        <div v-if="isSubmit && username === ''" class="text-danger">
          กรุณากรอก Username
        </div>
      </div>
      <div class="password">
        <label for="passwordInput">Password: </label>
        <b-form-input
          id="passwordInput"
          v-model="password"
          type="password"
          placeholder="Enter Password"
          required></b-form-input>
        <div v-if="isSubmit && password === ''" class="text-danger">
          กรุณากรอก Password
        </div>
      </div>
      <div class="text-center mt-7">
        <button class="btn btn-outline-white" type="submit">Login</button>
      </div>
      <div class="text-center mt-3">
        <span
          style="color: #fff; text-decoration: underline; cursor: pointer"
          @click="() => $router.push({ name: 'ResetPass' })">
          Forgot Password
        </span>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      username: "",
      password: "",
      isSubmit: false,
      isLoading: false,
    };
  },
  created() {
    window._login = this;
  },

  methods: {
    setStorage() {
      this.isSubmit = true;
      if (this.username === "" || this.password === "") {
        return;
      }
      const credentials = {
        username: this.username,
        password: this.password,
      };
      this.isLoading = true;
      this.$store
        .dispatch("account/login", credentials)
        .then(
          async (res) => {
            if (res) {
              const data = res.data;
              const roles = data.roles;
              const isAdmin = roles.includes("ROLE_ADMIN");
              const isBrandAdmin = roles.includes("ROLE_BRAND_ADMIN");
              const isBC = roles.includes("ROLE_BC");
              const isSalesSupervisor = roles.includes("ROLE_SALES_SUPERVISOR");
              this.$store.commit("account/saveLocalToken");
              const redirectRoute = this.$route.query.redirect;
              if (redirectRoute) {
                this.$router.push(redirectRoute);
              } else if (isBrandAdmin) {
                this.$router.push({ name: "Brand" });
              } else if (isBC || isSalesSupervisor) {
                this.$router.push({ name: "ResetCustomerPass" });
              } else if (isAdmin) {
                this.$router.push({ name: "Users" });
              }
            }
            this.isLoading = false;
          },
          (error) => {
            console.log("error", error);
            this.isLoading = false;
            alert("error: Can't Login.");
          }
        )
        .catch((error) => {
          //alert
          console.log("login:catch", error);
          alert("login:catch", error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isSubmit = false;
        });
    },
  },
  computed: {
    ...mapState({
      userId: (store) => store.account.userId,
    }),
  },
};
</script>

<style lang="scss" scoped>
.form {
  position: relative;
  top: 60px;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 1rem 0;
  width: 100%;
  max-width: 330px;

  .username {
    margin: 1rem 0;
    color: #fff;
  }

  .password {
    color: #fff;
  }
}

.centered {
  position: absolute; /* or absolute */
  top: 45%;
  left: 45%;
}

.btn-outline-white {
  color: #fff;
  border-color: #fff;
}

.btn:hover {
  color: #222;
  background: #fff;
  border-color: #222;
}
</style>
